import { boolean, object, optional } from 'superstruct';
import { makeRecord } from '@arc/shared/util-js';
import { permissionSystem } from './permissions';
const PermissionValuesDto = object(makeRecord(permissionSystem.actionTypes, () => optional(boolean())));
export const PermissionsDto = object(makeRecord(permissionSystem.permissionTypes, () => optional(PermissionValuesDto)));